<template>
    <div class="media user-profile mt-2 mb-2">
        <div class="media-body">
            <h6 class="pro-user-name mt-0 mb-0" :title="currentSpace.name">
                <template v-if="!spacesLoading">
                    <template v-if="currentSpace.id">
                        {{ currentSpace.name }}
                    </template>
                    <template v-else>
                        ------
                    </template>
                </template>
                <b-skeleton v-else width="70%" />
            </h6>
            <span class="pro-user-desc">
                <template v-if="!spacesLoading">
                    <template v-if="currentSpace.url">{{ currentSpace.url }}</template>
                    <template v-else>---</template>
                </template>
                <b-skeleton v-else width="40%" />
            </span>
        </div>
        <b-dropdown class="align-self-center flex-shrink-0" toggle-class="p-0">
            <template #button-content>
                <feather type="chevron-down" class="align-middle" />
            </template>
            <b-dropdown-item
                v-for="space in items"
                :key="space.id"
                :active="space === currentSpace"
                :disabled="!space.id"
                @click="setCurrentSpace(space)"
            >
                <span>{{ space.name }}</span>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>



<script>
    export default {
        name: 'SpaceSwitcher',
        computed: {
            spacesLoading() {
                return !!this.$store.state.space.loading.fetchSpaces;
            },
            spaces() {
                return Object.values(this.$store.state.space.spaces || {});
            },
            currentSpace() {
                return this.$store.getters['space/getCurrentSpace'] || { id: 0 };
            },
            items() {
                return this.spaces || [{ id: 0, name: `--${this.$t('noResult')}--` }];
            },
        },
        methods: {
            setCurrentSpace(space) {
                this.$store.dispatch('space/setCurrentSpace', { spaceId: space.id });
            },
        },
    };
</script>



<style lang="scss" scoped>
    .user-profile {
        display: flex;
        padding: 15px 20px 15px 30px;
        gap: 1rem;

        .media-body {
            overflow: hidden;
        }

        .avatar-xs {
            display: none;
        }

        .pro-user-name {
            color: $menu-item-color-dark;
            font-weight: $font-weight-semibold;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
        }

        .pro-user-desc {
            color: $menu-item-color-dark;
            font-size: 0.6rem;
            font-weight: 700;
            letter-spacing: 1px;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
        }

        ::v-deep {
            .dropdown-toggle {
                background-color: rgba($menu-item-color-dark, 0.1);
                border-color: rgba($menu-item-color-dark, 0.1);

                &:hover {
                    background-color: rgba($menu-item-color-dark, 0.2);
                    border-color: rgba($menu-item-color-dark, 0.2);
                }
            }
        }
    }

    .shop-logo.b-avatar {
        background: #fff;

        ::v-deep {
            .b-avatar-img img {
                object-fit: contain;
            }
        }
    }
</style>
